import { __decorate, __metadata } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import { beforeProperties } from '@dojo/framework/core/decorators/beforeProperties';
import { lccstore } from 'lcc-state';
import { publish, subscribe } from 'pub-sub';
import Button from '@dojo/widgets/button';
import { displayDate } from '../support/display-date';
import css from '../css/discussion.m.css';
let Comment = class Comment extends I18nThemed {
    render() {
        const { comment: { fullname, posted, comment } } = this.properties;
        return v('div', { key: posted, classes: [this.theme(css.comment)] }, [
            v('div', { key: 'user', classes: [this.theme(css.commentUser)] }, [fullname]),
            v('div', { key: 'date', classes: [this.theme(css.commentDate)] }, [displayDate(posted)]),
            v('div', { key: 'comment', classes: [this.theme(css.commentText)], innerHTML: comment })
        ]);
    }
};
Comment = __decorate([
    theme(css)
], Comment);
export { Comment };
let CommentEditor = class CommentEditor extends I18nThemed {
    data = '';
    setData = () => undefined;
    active = false;
    onAttach() {
    }
    update_comment(data) {
        this.data = data;
    }
    ensure_nls(properties) {
        const { get, path } = lccstore;
        const dynls = get(path('dynls'));
        const bundle = dynls.get('quiz');
        if (!bundle) {
            properties.localizedBundle = { isPlaceholder: true, format: null, messages: {} };
        }
        else {
            properties.localizedBundle = this.localizeBundle(bundle);
        }
        return properties;
    }
    async save_comment() {
        if (this.data.length > 1) {
            const { svc, resultid, reloadEssayPane } = this.properties;
            const comment = await svc.add_reply({ resultid, reply: this.data });
            publish('notify:event', {
                event: 'discussion:comment:add',
                recipient: '*',
                course: window.hcstatic.course_session.pk,
                message: {
                    resultid,
                    commentid: comment.commentid,
                    user: comment.fullname
                }
            });
            this.data = '';
            this.setData('');
            this.invalidate();
            reloadEssayPane();
        }
    }
    render_editor() {
        const { localizedBundle: { messages: { discPost = 'Post', discCancel = 'Cancel' } } } = this.properties;
        return v('div', { key: 'editor-view', xqa: `comment editor`, classes: [this.theme(css.commentEditor)] }, [
            w('Editor', {
                content: this.data,
                onContent: (content) => {
                    this.update_comment(content);
                }
            }),
            w(Button, {
                onClick: () => {
                    this.active = false;
                    this.save_comment();
                }
            }, [discPost]),
            w(Button, {
                onClick: () => {
                    this.data = '';
                    this.setData('');
                    this.active = false;
                    this.invalidate();
                }
            }, [discCancel])
        ]);
    }
    render_inactive() {
        const { localizedBundle: { messages: { discAddComment = 'Add Comment' } } } = this.properties;
        return v('div', { key: 'editor-view', xqa: `comment add`, classes: [this.theme(css.commentEditor)] }, [
            w(Button, {
                onClick: () => {
                    this.active = true;
                    this.invalidate();
                }
            }, [discAddComment])
        ]);
    }
    render() {
        const { active } = this;
        const { localizedBundle: { isPlaceholder } } = this.properties;
        if (isPlaceholder) {
            return null;
        }
        return active ? this.render_editor() : this.render_inactive();
    }
};
__decorate([
    beforeProperties(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Object)
], CommentEditor.prototype, "ensure_nls", null);
CommentEditor = __decorate([
    theme(css)
], CommentEditor);
export { CommentEditor };
let EssayPane = class EssayPane extends I18nThemed {
    handles = [];
    onAttach() {
        const { essay: { qrid }, reloadComments } = this.properties;
        const h = subscribe('discussion:comment:add', (topic, data) => {
            if (data.resultid === qrid) {
                reloadComments();
            }
        });
        this.handles.push(h);
    }
    onDetach() {
        this.handles.forEach((h) => {
            h.destroy();
        });
    }
    render() {
        const { essay: { fullname, posted, answer, qrid }, comments, reloadComments, svc } = this.properties;
        return v('div', { key: posted, classes: [this.theme(css.essayPane)] }, [
            v('div', { classes: [this.theme(css.essayUser)] }, [v('span', {}, [fullname])]),
            v('div', { classes: [this.theme(css.essayDate)] }, [v('span', {}, [displayDate(posted)])]),
            v('div', { classes: [this.theme(css.essayAnswer)], innerHTML: answer }),
            v('div', { xqa: `comment list`, classes: [this.theme(css.essayComments)] }, [
                ...comments.map((comment) => {
                    return w(Comment, { comment });
                }),
                w(CommentEditor, {
                    resultid: `${qrid}`,
                    svc,
                    reloadEssayPane: () => {
                        reloadComments();
                    },
                    localizedBundle: { isPlaceholder: true, format: null, messages: {} }
                })
            ])
        ]);
    }
};
EssayPane = __decorate([
    theme(css)
], EssayPane);
export { EssayPane };
let EssayItem = class EssayItem extends I18nThemed {
    render() {
        const { essay: { fullname, posted, excerpt }, key, selectItem, isSelected } = this.properties;
        return v('li', {
            key,
            classes: [this.theme(css.essayItem), isSelected ? this.theme(css.selectedEssayItem) : null],
            onclick: (evt) => {
                evt && evt.stopPropagation();
                selectItem(this.properties.essay);
            }
        }, [
            v('div', { classes: [this.theme(css.essayUser)] }, [v('span', {}, [fullname])]),
            v('div', { classes: [this.theme(css.essayDate)] }, [v('span', {}, [displayDate(posted)])]),
            v('div', { classes: [this.theme(css.essayFragment)] }, [excerpt])
        ]);
    }
};
EssayItem = __decorate([
    theme(css)
], EssayItem);
export { EssayItem };
